import type { Buyer } from '../types/content';

export const buyers: Buyer[] = [
  { name: 'María Fernanda L.', country: 'Mexico' },
  { name: 'Carlos R.', country: 'Colombia' },
  { name: 'Lucía M.', country: 'Argentina' },
  { name: 'Javier S.', country: 'Spain' },
  { name: 'Valentina P.', country: 'Chile' },
  { name: 'Andrés G.', country: 'Peru' },
  { name: 'Sofía D.', country: 'Uruguay' },
  { name: 'Diego H.', country: 'Venezuela' },
  { name: 'Camila V.', country: 'Ecuador' },
  { name: 'José Luis C.', country: 'Guatemala' },
  { name: 'Daniela Q.', country: 'Costa Rica' },
  { name: 'Mateo B.', country: 'Paraguay' },
  { name: 'Gabriela T.', country: 'Bolivia' },
  { name: 'Ricardo N.', country: 'Dominican Republic' },
  { name: 'Paula A.', country: 'Panama' },
  { name: 'Fernando E.', country: 'Honduras' },
  { name: 'Ana Isabel O.', country: 'El Salvador' },
  { name: 'Luis F.', country: 'Puerto Rico' },
  { name: 'Isabella J.', country: 'Nicaragua' },
  { name: 'Alejandro K.', country: 'Cuba' },
];
